import { gql } from "@apollo/client";

const EMAIL_INGEST_RECIPIENTS = gql`
  query emailRecipients {
    recipients {
      email
      rules {
        id
        senderGlob
        subjectGlob
        senderRegex
        subjectRegex
        path
        matchOrder
      }
    }
  }
`;

const EMAIL_INGEST_SAVE_MATCH = gql`
  mutation saveEmailMatch($id: String, $recipient: String, $deactivate: Boolean, $rule: RuleInput) {
    save_emailmatch(id: $id, recipient: $recipient, deactivate: $deactivate, rule: $rule) {
      ... on SaveEmailMatchOk {
        email
        rules {
          id
          senderGlob
          subjectGlob
          senderRegex
          subjectRegex
          path
          matchOrder
        }
      }
      ... on InvalidRegexError {
        field
        message
      }
      ... on InvalidPathError {
        field
        message
      }
    }
  }
`;

const EMAIL_INGEST_SAVE_RECIPIENT = gql`
  mutation saveEmailRecipient($recipient: String!, $newRecipient: String, $deactivate: Boolean) {
    save_emailrecipient(recipient: $recipient, newRecipient: $newRecipient, deactivate: $deactivate) {
      ... on SaveEmailRecipientOk {
        newEmail
        oldEmail
      }
      ... on RecipientAlreadyExistsError {
        field
        message
      }
    }
  }
`;

export { EMAIL_INGEST_RECIPIENTS, EMAIL_INGEST_SAVE_MATCH, EMAIL_INGEST_SAVE_RECIPIENT };
